const SET_EXPORTS_INFO = 'SET_EXPORTS_INFO';
const SET_LOADING = 'SET_EXPORTS_QUEUE_LOADING';

export default {
    SET_EXPORTS_INFO,
    SET_LOADING
};
